import { useState, useCallback, useEffect } from 'react'
import { Form } from 'react-bootstrap'
import Swal from 'sweetalert2'
import styled from 'styled-components'

import { AdjustColumns, Hr, Price, Input } from '../../styles'
import { CANCEL_REASON, OBJ_BG_COLORS, STATUS } from '../../constants'
import { alertCompleted, alertError, alertBeforeHandle } from '../../utils'
import {
  approveOrder,
  getOrdersByStatus,
  cancelOrder,
  saveNoteInOrder,
  getOrdersLocked,
} from '../../Services/serviceAdmin'
import Colors from '../../../../constants/Colors'
import { formatPrice } from '../../../../helpers/utils'

const ChecklistInfo = ({ order, slips, remainingAmount, setOrders, status, fetchOrderAferUpdateStatus }) => {
  const [isReasonCancel, setIsReasonCancel] = useState(false)
  const [cancelReason, setCancelReason] = useState('')
  const [note, setNote] = useState(order?.note || '')

  useEffect(() => {
    setNote(order?.note || '')
    setIsReasonCancel(false)
    setCancelReason('')
  }, [order?.note, setNote])

  const fetchOrdersAfterAction = useCallback(async () => {
    await alertCompleted()
    const response = (await status) === 'LOCKED' ? getOrdersLocked() : getOrdersByStatus(order?.status)
    if (response.length > 0) {
      const notIssue = response.filter((v) => (status === 'ISSUE' ? v.isIssue : !v.isIssue))
      setOrders(notIssue)
    }
  }, [order?.status, setOrders, status])

  const approve = async (hashId) => {
    const response = await approveOrder(hashId)
    if (response.success) {
      await fetchOrderAferUpdateStatus(status)
      setCancelReason('')
    } else {
      alertError()
    }
  }

  const cancel = useCallback(
    async (hashId) => {
      const isForce = order.status === 'SUCCESS' ? true : false

      const response = await cancelOrder(hashId, cancelReason, isForce)
      if (response.success) {
        await fetchOrderAferUpdateStatus(status)
        setCancelReason('')
        setIsReasonCancel(false)
      } else {
        alertError()
        setCancelReason('')
      }
    },
    [cancelReason, fetchOrderAferUpdateStatus, status],
  )

  const popupCancelOrder = useCallback(() => {
    Swal.fire({
      title: `เหตุผลที่เลือก ${cancelReason}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: Colors.SOFT_BLUE,
      cancelButtonColor: Colors.LIGHT_RED,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await cancel(order?.id)
      } else if (result.isDismissed) {
        setCancelReason('')
      }
    })
  }, [cancelReason, cancel, order?.id])

  useEffect(() => {
    if (cancelReason) {
      popupCancelOrder()
    }
  }, [cancelReason, popupCancelOrder])

  const saveNote = async (hashId) => {
    const response = await saveNoteInOrder(hashId, note)
    if (response?.success) {
      await fetchOrdersAfterAction()
    } else {
      alertError()
    }
  }

  const paid = () => {
    const amount = order?.totalPrice
    const pay = amount - remainingAmount
    return (
      <>
        <AdjustColumns>
          <div>ชำระมาแล้ว</div>
          <Price>{formatPrice(pay)} บาท</Price>
        </AdjustColumns>
        <AdjustColumns>
          {remainingAmount < 0 ? (
            <>
              <div>ชำระมาเกิน</div>
              <Price>{formatPrice(Math.abs(remainingAmount))} บาท</Price>
            </>
          ) : (
            <>
              <div>ค้างชำระ</div>
              <Price>{formatPrice(remainingAmount)} บาท</Price>
            </>
          )}
        </AdjustColumns>
      </>
    )
  }

  if (!order) return false

  const isShow = order?.status === 'OPEN' || order?.status === 'CONFIRMED'
  const isCancelButtonDisplay = order?.status !== 'CANCEL'

  return (
    <>
      <Title>รายการตรวจสอบ</Title>
      <Hr />
      <AdjustColumns>
        <div>สถานะ</div>
        <ButtonStatusGroup>
          <span style={{ color: OBJ_BG_COLORS[order?.status] }}>{STATUS[order?.status]}</span>
          {isShow && (
            // <>
            <ButtonStatus
              color={Colors.GREEN}
              onClick={() => alertBeforeHandle('เปลี่ยนสถานะเป็นซื้อสำเร็จ', () => approve(order?.id))}
              className="ml-1"
            >
              ซื้อสำเร็จ
            </ButtonStatus>
          )}

          {/* เก็บไว้ก่อน order สำหรับ lottery มีปุ่มนี้แต่ว่า order สำหรับ slot ไม่ต้องมีปุ่มนี้
              แต่ทำไปแล้วมี flow และ api เยอะ ถ้าลบทิ้งแล้วถ้ามี feature ที่ต้องมีการสร้างใหม่จะนาน By พรี่เป้ */}
          {isCancelButtonDisplay && (
            <ButtonStatus color={Colors.LIGHT_RED} onClick={() => setIsReasonCancel(true)} className="ml-1">
              ยกเลิก
            </ButtonStatus>
          )}
          {/* </> */}
        </ButtonStatusGroup>
      </AdjustColumns>
      {isReasonCancel && (
        <Form.Group>
          <Form.Control as="select" value={cancelReason} onChange={(e) => setCancelReason(e.target.value)}>
            <option value="">กรุณาเลือก</option>
            {CANCEL_REASON.map((reason) => {
              return (
                <option key={reason} value={reason}>
                  {reason}
                </option>
              )
            })}
          </Form.Control>
        </Form.Group>
      )}
      {order.status === 'CANCEL' && order?.reason && (
        <AdjustColumns>
          <div>เหตุผลที่ยกเลิก</div>
          <div>{order?.reason}</div>
        </AdjustColumns>
      )}
      <AdjustColumns>
        <div>ยอดรวม</div>
        <Price>{formatPrice(order?.totalPrice)} บาท</Price>
      </AdjustColumns>
      {slips.length > 0 && paid()}
      <AdjustColumns>
        <div>โน๊ต</div>
        <Input type="text" value={note} onChange={(e) => setNote(e.target.value)} />
        <SaveNoteButton onClick={() => saveNote(order?.id)}>บันทึก</SaveNoteButton>
      </AdjustColumns>
    </>
  )
}

export default ChecklistInfo

const Title = styled.h4`
  margin-top: 20px;
`
const SaveNoteButton = styled.div`
  padding: 10px 20px;
  &:hover {
    cursor: pointer;
    box-shadow:
      rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
      rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
  }
  box-shadow: rgba(0, 0, 0, 0.8) 1.95px 1.95px 2.6px;
  color: ${Colors.WHITE};
  background-color: ${Colors.GREEN};
`
const ButtonStatus = styled.div`
  padding: 10px;
  width: 120px;
  text-align: center;
  cursor: pointer;
  border: 1px solid ${({ color }) => color};
  &:hover {
    box-shadow:
      rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
      rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
    color: ${Colors.WHITE};
    background-color: ${({ color }) => color};
  }
`
const ButtonStatusGroup = styled.div`
  display: flex;
  gap: 1px;
  justify-content: space-between;
  align-items: center;
`
